export function create(state, notification) {
  const limit = 100;
  if (state.notifications.length >= limit) {
    state.notifications = state.notifications.slice(0, limit - 1);
  }
  state.notifications.unshift(notification);
}

export function remove(state, notificationUid) {
  if (!notificationUid) {
    return;
  }
  state.notifications = state.notifications.filter((n) => n.uid !== notificationUid);
}

export function removeAll(state) {
  state.notifications = [];
}

export function setReadStatus(state, { uid, status }) {
  if (!uid || status === undefined) {
    return;
  }
  const notification = state.notifications.find((n) => n.uid === uid);
  if (notification) {
    notification.read = status;
  }
}

export function markAsRead(state, uid) {
  setReadStatus(state, { uid, status: true });
}

export function markAsUnread(state, uid) {
  setReadStatus(state, { uid, status: false });
}

export function setNetworkError(state, status) {
  state.networkError = status;
}
